import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { Notification } from '@/types/notifications';

interface Props {
  notification: Notification;
  onClick: (n: Notification) => void;
  onDismiss: (id: string) => void;
}

export function NotificationItem({ notification, onClick, onDismiss }: Props) {
  const unread = !notification.read_at;
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onClick(notification)}
      onKeyDown={(e) => { if (e.key === 'Enter') onClick(notification); }}
      className={`group relative flex cursor-pointer flex-col gap-1 rounded-md border p-3 text-left
                  hover:bg-accent ${unread ? 'border-l-2 border-l-primary' : ''}`}
    >
      <div className="flex items-start justify-between gap-2">
        <span className="text-sm font-medium">{notification.title}</span>
        <Button
          variant="ghost"
          size="icon"
          className="h-5 w-5 shrink-0 opacity-0 group-hover:opacity-100"
          aria-label="Dismiss notification"
          onClick={(e) => { e.stopPropagation(); onDismiss(notification.id); }}
        >
          <X className="h-3 w-3" />
        </Button>
      </div>
      {notification.body && (
        <span className="text-xs text-muted-foreground">{notification.body}</span>
      )}
      <span className="text-[10px] text-muted-foreground">
        {new Date(notification.created_at).toLocaleString()}
      </span>
    </div>
  );
}
